module.exports = __webpack_public_path__ + "static/media/Glowing_Container@3x.8e569ab0.png";